import { DynamicSetting, DynamicSettingValueType } from '@k3/core'

export const additionalDynamicSettings: DynamicSetting[] = [
  {
    key: 'invalidRuleModalTitle',
    valueType: DynamicSettingValueType.TRANSLATION,
    label: 'Überschreibendialogtitel',
    defaultValue: 'Überschreiben',
  },
  {
    key: 'invalidRuleModalText',
    valueType: DynamicSettingValueType.TRANSLATION,
    label: 'Überschreibendialogtext',
    defaultValue:
      'Die von Ihnen gewählte Option steht in Konflikt mit einer anderen bereits gewählten Option.\n\nMöchten Sie mit der neuen Option überschreiben?',
  },
]
